import { FullContainer } from '@gorila-shared-ui/components';
import { useStyles } from '../../../hooks/useStyles';
import { FleetAssetList } from '../../fleet/assets/FleetAssetList';
import FleetAssetsFiltersBar from '../../fleet/assets/FleetAssetsFiltersBar';

function FleetAssetsPage() {
  const { classes } = useStyles();

  return (
    <FullContainer
      verticalFlex
      classNames={classes.basicPageContainer}
    >
      <FleetAssetsFiltersBar />
      <FleetAssetList />
    </FullContainer>
  );
}

export default FleetAssetsPage;
